export const env = {
  version: import.meta.env.VITE_APP_VERSION,

  api_url: import.meta.env.VITE_APP_API_URL as string,
  login_url: import.meta.env.VITE_APP_LOGIN_URL as string,
  proxy_url: import.meta.env.VITE_APP_PROXY_URL as string,
  proxy_atlantic_url: import.meta.env.VITE_APP_PROXY_ATLANTIC_URL as string,
  proxy_thermor_url: import.meta.env.VITE_APP_PROXY_THERMOR_URL as string,
  proxy_plateforme_service_url: import.meta.env.VITE_APP_PROXY_PLATEFORME_SERVICE_URL as string,
  proxy_spareparts_app_url: import.meta.env.VITE_APP_PROXY_SPAREPARTS_APP_URL as string,
  proxy_pacific_url: import.meta.env.VITE_APP_PROXY_PACIFIC_URL as string,

  api_url_int: import.meta.env.VITE_APP_API_URL_INT as string,
  api_url_pro: import.meta.env.VITE_APP_API_URL_PRO as string,
  api_url_old: import.meta.env.VITE_APP_API_URL_OLD as string,

  app_url_atlantic_int: import.meta.env.VITE_APP_URL_Atlantic_INT as string,
  app_url_atlantic_fr: import.meta.env.VITE_APP_URL_Atlantic_FR as string,
  app_url_thermor_int: import.meta.env.VITE_APP_URL_Thermor_INT as string,
  app_url_thermor_fr: import.meta.env.VITE_APP_URL_Thermor_FR as string,
  app_url_acv: import.meta.env.VITE_APP_URL_ACV as string,
  app_url_acv_fr: import.meta.env.VITE_APP_URL_ACV_FR as string,
  app_url_autres_marques: import.meta.env.VITE_APP_URL_Autres_marques as string,
  app_url_equation_welcome: import.meta.env.VITE_APP_URL_Equation_Welcome as string,
  app_url_oem: import.meta.env.VITE_APP_URL_OEM as string,
  app_url_pacific: import.meta.env.VITE_APP_URL_Pacific as string,
  app_url_sauter: import.meta.env.VITE_APP_URL_Sauter as string,
  app_url_ygnit_int: import.meta.env.VITE_APP_URL_Ygnis_INT as string,
  app_url_orcon_int: import.meta.env.VITE_APP_URL_Orcon_INT as string,

  api_end_point: import.meta.env.VITE_APP_API_END_POINT as string,
  api_token_url: import.meta.env.VITE_APP_API_TOKEN_URL as string,
  back_api_url: import.meta.env.VITE_APP_BACK_API_URL as string,
  allowed_redirect_hosts: import.meta.env.VITE_APP_ALLOWED_REDIRECT_HOSTS as string,
  
  port: import.meta.env.VITE_PORT as string,

  getAllKeys: ()=> Object.keys(import.meta.env).filter(key => key.startsWith('VITE_APP_'))
};

/*
REACT_APP_API_URL_INT='https://brand.ogma.spareparts-app.com'
REACT_APP_API_URL_PRO='https://espace-sav.ogma.brand-pro.fr'
REACT_APP_API_URL_PROS='https://espace-sav.ogma.brand-pros.fr'
REACT_APP_API_URL_OLD='https://brand.ogma.plateforme-services.com'
REACT_APP_API_URL='https://apis-tst.groupe-atlantic.com'
REACT_APP_API_END_POINT='/dev/pfs/espace-sav'
REACT_APP_BACK_API_URL='http://localhost:8000/api/settings'
REACT_APP_VERSION=${npm_package_version}

REACT_APP_URL_Atlantic_INT = 'https://nv.atlantic.ogma.spareparts-app.com'
#REACT_APP_URL_Atlantic_FR = 'https://nv.espace-sav.ogma.atlantic-pros.fr'
REACT_APP_URL_Atlantic_FR = 'https://app-espacesav-front-dev-5600.azurewebsites.net'
REACT_APP_URL_Thermor_INT = 'https://nv.thermor.ogma.spareparts-app.com'
REACT_APP_URL_Thermor_FR = 'https://nv.espace-sav.ogma.thermor-pro.fr'
REACT_APP_URL_ACV = 'https://nv.acv.ogma.plateforme-services.com'
REACT_APP_URL_ACV_FR = 'https://acv.plateforme-services.com'
REACT_APP_URL_Autres_marques = 'https://nv.autres-marques.ogma.plateforme-services.com'
REACT_APP_URL_Equation_Welcome = 'https://nv.equation-welcome.ogma.plateforme-services.com'
REACT_APP_URL_OEM = 'https://nv.oem.ogma.plateforme-services.com'
REACT_APP_URL_Pacific = 'https://nv.espace-sav.ogma.pacific-pros.fr'
REACT_APP_URL_Sauter = 'https://nv.sauter.ogma.plateforme-services.com'
REACT_APP_URL_Ygnis_INT = 'https://nv.ygnis.ogma.spareparts-app.com'
 */